import React from 'react';

const SpinnerWithBackground = (props) => {
  return (
    <div className={`spinner-background ${props.bgClass}`}>
      <div className={props.loadClass}>
        <div className="orange-spinner"></div>
        <p>{props.text}</p>
      </div>
    </div>
  )
}

export default React.memo(SpinnerWithBackground);



// WEBPACK FOOTER //
// ./src/components/shared/spinner-background.js